import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import {
  ArrowGraphicOuter,
  ArrowGraphicWrapper,
  Row,
  Left,
  Right,
  Para,
} from './ArrowGraphic.styles'
import { HeadingText, ParagraphText } from '../../HowItWorks.styles'
import arrow from '../../../../images/HIWArrow.png'

const ArrowGraphic = ({
  leftP,
  rightP,
  mainG,
  head,
  headMax,
  arrowPosition,
}) => {
  return (
    <ArrowGraphicOuter>
      <ArrowGraphicWrapper>
        <Left>
          <img
            src={arrow}
            alt=""
            style={{
              transform:
                (!!arrowPosition && `translateY(${arrowPosition}px)`) ||
                'translateY(130px)',
            }}
          />
        </Left>
        <Right>
          <HeadingText
            style={{ maxWidth: headMax || '598px', marginBottom: '3.4rem' }}
          >
            {head}
          </HeadingText>
          <Row>
            <GatsbyImage
              image={mainG}
              className="mainImg"
              style={{ width: '100%' }}
              alt=""
            />
            <Para className="para">
              <ParagraphText
                style={{ marginBottom: '8px', fontWeight: 'bold' }}
              >
                {rightP.head}
              </ParagraphText>
              <p style={{ marginBottom: '2rem', color: '#4b4b4b' }}>
                {rightP.para}
              </p>
              <GatsbyImage image={rightP.rowGraphic} alt="" />
            </Para>
          </Row>
        </Right>
      </ArrowGraphicWrapper>
      <div className="paragraph">
        <Para>
          <ParagraphText style={{ marginBottom: '8px', fontWeight: 'bold' }}>
            {leftP.head}
          </ParagraphText>
          <p style={{ color: '#4b4b4b' }}>{leftP.para}</p>
        </Para>
      </div>
    </ArrowGraphicOuter>
  )
}

export default ArrowGraphic
